var map = {
	"./asset-hyperlink.json": 52879,
	"./blockquote.json": 66197,
	"./document.json": 64627,
	"./embedded-asset-block.json": 63857,
	"./embedded-entry-block.json": 87709,
	"./embedded-entry-inline.json": 87379,
	"./embedded-resource-block.json": 35293,
	"./embedded-resource-inline.json": 39795,
	"./entry-hyperlink.json": 65535,
	"./heading-1.json": 98016,
	"./heading-2.json": 35361,
	"./heading-3.json": 86394,
	"./heading-4.json": 93224,
	"./heading-5.json": 3916,
	"./heading-6.json": 60317,
	"./hr.json": 9212,
	"./hyperlink.json": 10438,
	"./list-item.json": 42372,
	"./ordered-list.json": 1518,
	"./paragraph.json": 28818,
	"./resource-hyperlink.json": 34437,
	"./table-cell.json": 78441,
	"./table-header-cell.json": 12777,
	"./table-row.json": 24641,
	"./table.json": 29528,
	"./text.json": 99849,
	"./unordered-list.json": 36325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89746;